// Toutes les briques, avec leur phase et leur client, pour le choix de rattachement.
export const allBricks = (clients) =>
  (clients || []).flatMap((c) =>
    (c.phases || []).flatMap((ph) =>
      (ph.briques || []).map((b) => ({
        id: b.id,
        label: `${ph.nom} / ${b.nom}`,
        clientId: c.id,
        phaseId: ph.id,
        clientName: c.nom,
        nom: b.nom,
      })),
    ),
  );
